import React, { Suspense, lazy } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { MainLayout } from './layouts';
import { Login, Register } from './pages/Auth';

// Lazy load heavy pages (reduces initial bundle by ~60%)
const IndiaDashboard = lazy(() => import('./pages/India/Dashboard'));
const IndiaBrokers = lazy(() => import('./pages/India/Brokers'));
const IndiaCopyTrading = lazy(() => import('./pages/India/CopyTrading'));
const Infrastructure = lazy(() => import('./pages/India/Infrastructure'));
const Performance = lazy(() => import('./pages/India/Performance'));
const AdminDashboard = lazy(() => import('./pages/Admin/AdminDashboard'));

// Loading fallback - minimal spinner
function PageLoader() {
  return (
    <div className="flex items-center justify-center h-64">
      <div className="w-8 h-8 border-2 border-accent-primary border-t-transparent rounded-full animate-spin" />
    </div>
  );
}

// Protected Route wrapper
function ProtectedRoute({ children }) {
  const token = localStorage.getItem('access_token');
  if (!token) {
    return <Navigate to="/login" replace />;
  }
  return children;
}

// Public Route wrapper (redirect if authenticated)
function PublicRoute({ children }) {
  const token = localStorage.getItem('access_token');
  if (token) {
    return <Navigate to="/dashboard" replace />;
  }
  return children;
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          {/* Public Routes */}
          <Route
            path="/login"
            element={
              <PublicRoute>
                <Login />
              </PublicRoute>
            }
          />
          <Route
            path="/register"
            element={
              <PublicRoute>
                <Register />
              </PublicRoute>
            }
          />

          {/* Protected Routes - Indian Copy Trading */}
          <Route element={<MainLayout />}>
            <Route
              path="/dashboard"
              element={
                <Suspense fallback={<PageLoader />}>
                  <IndiaDashboard />
                </Suspense>
              }
            />
            <Route
              path="/brokers"
              element={
                <Suspense fallback={<PageLoader />}>
                  <IndiaBrokers />
                </Suspense>
              }
            />
            <Route
              path="/copy"
              element={
                <Suspense fallback={<PageLoader />}>
                  <IndiaCopyTrading />
                </Suspense>
              }
            />
            <Route
              path="/performance"
              element={
                <Suspense fallback={<PageLoader />}>
                  <Performance />
                </Suspense>
              }
            />
            <Route
              path="/infrastructure"
              element={
                <Suspense fallback={<PageLoader />}>
                  <Infrastructure />
                </Suspense>
              }
            />
            <Route
              path="/admin"
              element={
                <Suspense fallback={<PageLoader />}>
                  <AdminDashboard />
                </Suspense>
              }
            />
          </Route>

          {/* Redirects */}
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
